import { OffsetPaginated } from 'types/pagination';
import { UserMetric } from 'types/user_metric';

/** Helper function to retrieve the metric dimensions in the {@link useUserMetrics} response object  */
export function getDimensionsFromMetricsResponse(
  metric: string,
  userMetrics?: OffsetPaginated<UserMetric>
) {
  return (
    userMetrics?.data.find(({ name }) => name === metric)?.dimensions || []
  );
}
